<script setup lang="ts">
  import { RouterView } from 'vue-router';
  import defaultLogo from '@/assets/images/logo-placeholder.png';
  import changeItLogo from '@/assets/images/change-it-logo.svg';
  import { useThemeStore } from "@/stores/theme";
  import { useAppStore } from "@/stores/app";

  const themeStore = useThemeStore();
  const logo = themeStore.logo ?? defaultLogo;

  const appStore = useAppStore();
</script>

<template>
  <v-layout>
    <v-app-bar class="header" elevation="0">
      <v-container>
        <v-row class="justify-space-between">
          <div class="client-logo">
            <img class="logo" :src="logo" alt="Logo">
          </div>
          <a
            v-if="!appStore.isSubscriptionProgram && !appStore.isWhiteLabel"
            class="change-it-logo"
            :href="$theme.getAnchor('change_it_logo').href"
            target="_blank"
          >
            <img :src="changeItLogo">
          </a>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
  </v-layout>
</template>

<style lang="scss" scoped>
  .header {
    border-bottom: 1px solid rgb(var(--v-theme-neutral-200));

    .logo {
      height: 50px;
    }

    .change-it-logo, .client-logo {
      display: flex;
      align-items: center;
    }
  }
</style>
